import { memo } from 'react';

import blurredBackground from '@/assets/bg-blurred.webp';
import { Button, Flex, Heading, Text } from '@/components/core';

import { CloseIcon, WarningDuotoneIcon } from '../icons';

export type FullscreenErrorProps = {
  error: Error;
  onDismiss?: () => void;
  dismissLabel?: string;
};

const IFullscreenError = ({ error, onDismiss, dismissLabel }: FullscreenErrorProps) => {
  return (
    <div
      className="flex h-screen w-full items-center justify-center overflow-hidden bg-cover bg-center"
      style={{ backgroundImage: `url(${blurredBackground})` }}
    >
      <Flex
        variant="secondary"
        col
        className="relative w-[18rem] items-center justify-center gap-4 rounded-lg p-4 shadow-md"
      >
        <Button variant="plain" className="absolute top-0 right-0 mt-1 mr-1" onPress={onDismiss}>
          <CloseIcon />
        </Button>

        <div className="ring-error-50 border-error-100 flex items-center justify-center rounded-full border-4 ring-4">
          <WarningDuotoneIcon variant="error" />
        </div>

        <div className="flex flex-col items-center justify-center">
          <Heading size="sm">Oops! Something went wrong.</Heading>
          <Text>{error.message}</Text>
        </div>

        <Text size="xs" className="text-center text-gray-500">
          Reach out through{' '}
          <span onClick={() => window._chatlio?.open()} className="cursor-pointer font-semibold underline">
            chat
          </span>{' '}
          or email us at <span className="font-semibold">support@cradl.ai</span> if the problem persists.
        </Text>

        <Button variant="primary" onPress={onDismiss}>
          <Text>{dismissLabel ?? 'Refresh'}</Text>
        </Button>
      </Flex>
    </div>
  );
};

export const FullscreenError = memo(IFullscreenError) as typeof IFullscreenError;
